<svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
  <path d="M2 14.5H15" stroke="#E5E5E5" stroke-width="1.4" stroke-linecap="round"/>
  <path d="M3.5 14.5V4H6.5V14.5" stroke="#E5E5E5" stroke-width="1.2" stroke-linecap="round"/>
  <rect x="4.1" y="5.5" width="1.8" height="6.5" rx="0.4" fill="#E5E5E5"/>
  <path d="M8.5 14.5V9.5H11.5V14.5" stroke="#E5E5E5" stroke-width="1.3" stroke-linecap="round"/>
  <circle cx="10" cy="7" r="1.3" fill="#E5E5E5"/>
  <path d="M8 10.5L9.5 12L11 10.5" stroke="#E5E5E5" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
